import { SiteTypeValue } from '../js_env';

export class FavoriteItemJsEnv {
  isError: boolean;
  errorCode: string;
  errorMessage: string;
  sImage: string;

  constructor(
    isError: boolean,
    errorCode: string,
    errorMessage: string,
    sImage: string,
  ) {
      this.isError = isError;
      this.errorCode = errorCode;
      this.errorMessage = errorMessage;
      this.sImage = sImage;
    }

  static error(response: any) {
    return new FavoriteItemJsEnv(
      true,
      response.data.errors[0].code,
      response.data.errors[0].message,
      ""
    );
  }

  static success(response: any) {
    return new FavoriteItemJsEnv(
       false,
       "",
       "",
       response,
    );
  }
}

export class FavoriteItemParameter {
  itemSupplierId: string;
  catalogItemCode: string;
  folderShareType: number;
  folderCode: number;
  siteType: number;
  folderManagerId: string;

  constructor(
    itemSupplierId: string,
    catalogItemCode: string,
    folderShareType: number,
    folderCode: number,
    siteType: SiteTypeValue,
    folderManagerId: string,
  ) {
      this.itemSupplierId = itemSupplierId;
      this.catalogItemCode = catalogItemCode;
      this.folderShareType = folderShareType;
      this.folderCode = folderCode;
      this.siteType = Number(siteType);
      this.folderManagerId = folderManagerId;
  }
}
